import { selectAppPersistI18n } from '@store/useAppStorePersist';

const useTranslation = () => {
  const translates = selectAppPersistI18n();

  const t = (text, fields, isMatch) => {
    if (!text) {
      return '';
    }

    let translate;

    const matches = text.match(/_\[(.*?)]_/g) || [];

    if (!isMatch) {
      text = text.replace("'", "\\'");
    }

    if (matches.length) {
      matches.forEach(
        (match) => (text = text.replace(match, t(match.substring(2, match.length - 2), {}, true))),
      );
      translate = text;
    } else {
      translate = translates[text] || text;
    }

    if (Object.keys(fields || {}).length) {
      Object.keys(fields).forEach((field) => {
        translate = translate.replaceAll(`{${field}}`, fields[field]);
      });
    }

    if (!isMatch) {
      return translate.replaceAll('\\"', '"').replaceAll("\\'", "'");
    }

    return translate;
  };

  return { t };
};

export default useTranslation;
